import { uiLanguageFromBcp47 } from "@momo/i18n";
import { setLocale } from "@momo/views";
import "./firebase.ts";
import "./staff/session.sync.ts";
import "./staff/notice.sync.ts";
import "./backoffice/backoffice.sync.ts";
import "./backoffice/revia-backoffice.view.ts";

// Before the first render, so the sign-in and the lists open in one language.
let stored: string | null = null;
try {
	stored = localStorage.getItem("momo/language");
} catch {}
setLocale(stored === "de" || stored === "en" ? stored : uiLanguageFromBcp47(navigator.language, "de"));

// DEV-ONLY Kevin bridge. import.meta.env.DEV is a build-time constant, so this
// branch is dropped from a production bundle. The glob, not a plain dynamic
// import, keeps tsc and Vite from resolving the file where it is absent; the
// entry is called as a statement so the bundler cannot drop it as pure.
if (import.meta.env.DEV) {
	const load = import.meta.glob("./kevin.mount.ts")["./kevin.mount.ts"];
	if (load)
		load().catch((err: unknown) => {
			console.warn("[kevin] gesture listener failed to load", err);
		});
}

// Kevin's summon on every build: the listener alone, the inspector on the
// gesture (kevin-summon.mount.ts). Same glob indirection, for the same reason.
{
	const load = import.meta.glob("./kevin-summon.mount.ts")[
		"./kevin-summon.mount.ts"
	];
	if (load)
		load().catch((err: unknown) => {
			console.warn("[kevin] summon listener failed to load", err);
		});
}
